import React from 'react';
import './Testimonial.scss';
import { AppWrap, MotionWrap } from '../../wrapper';

const Testimonial = () => {
  return <div>Testimonial</div>;
};

export default AppWrap(
  MotionWrap(Testimonial, 'app__testimonial'),
  'testimonial',
  'app__primarybg'
);
